<template>
  <div class="home">
    <div class="text-center">
      <img :src="this.$commonUrl.cos() + '/image/logo.png'" />
      <b>万顺叫车</b>
      <p>一键叫车 极速用车</p>
    </div>
    <div class="" v-if="show">
      <div @click="goback" style="margin-bottom:20px">1111</div>
       <div @click="fail">2222</div>
    </div>
  </div>
</template>

<script>
import footComponent from "@/components/footer.vue";
  import wx from 'weixin-js-sdk';
export default {
  name: "home",
  components: {
    footComponent,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    let self = this;
    window.history.pushState(null, null, "");
    window.addEventListener("popstate", function (e) {
      window.history.pushState(null, null, "");
      console.log("2222");
      self.show = true;
    });
  },
  methods: {
    goback(){
        wx.miniProgram.navigateBack();
    },
    fail(){
       this.show = false;
    }
  },
};
</script>
<style lang="less" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  b {
    display: block;
    color: #f05259;
    font-size: 18px;
  }

  p {
    padding: 5px 0;
    font-size: 13px;
    color: #999999;
    font-weight: 500;
  }
}
</style>
